<template>
    <div class="account flex-height-max">
        <div class="action-header">
            <div class="action-header__title">
                Overview
            </div>
        </div>

        <div class="account__actions actions">
            <div class="actions__search-container">
                <input @input="getAccountData()" class="actions__search-input" v-model="filter.query" type="text" placeholder="Search by Google Ads ID or name"/>
                <inline-svg
                    class="actions__search-icon"
                    src="/images/search.svg" aria-label="search">
                </inline-svg>
                <inline-svg
                    v-show="filter.query"
                    @click="clearSearch()"
                    class="clear-search"
                    src="/images/clear.svg" aria-label="clear">
                </inline-svg>
            </div>
        </div>

        <div class="account__table main-table flex-height-max">
            <table class="main-table__wrapper">
                <thead class="main-table__header">
                <th class="main-table__header-item">
                    <span @click="sortTable($event, 'id', 'ASC')" class="table-header-sort noselect">
                        <span>
                           Google Ads ID
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                <th class="main-table__header-item">
                    <span @click="sortTable($event, 'name', 'ASC')" class="table-header-sort noselect">
                        <span>
                            Google Ads account
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                <th class="main-table__header-item">
                    <span class="table-header-sort noselect" style="cursor: default;">
                        <button class="question-tooltip" @click="showModal('proxy-blocking-help-modal')">
                            <span>
                                Proxy blocking
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
                        </button>
                    </span>
                </th>
                <th v-if="ccb_feature" class="main-table__header-item">
                    <span class="table-header-sort noselect">
                        <span data-toggle="tooltip" data-placement="top" title="With the Cross Campaign Blocking enabled, the detected IP address will be blocked across your Google Ads account campaigns." data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner blocking-setting-ccb"></div></div>'>
                            Cross Campaign Blocking
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                <th class="main-table__header-item">
                    <span @click="sortTable($event, 'threshold', 'ASC')" class="table-header-sort noselect">
                        <span>
                            Threshold rule
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                <th class="main-table__header-item">
                    <span class="table-header-sort noselect" style="cursor: default;">
                        <button class="question-tooltip" style="color: inherit;" @click="showModal('unblock-ip-help-modal')">
                            <span>
                                Unblock IP after
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
                        </button>
                    </span>
                </th>
                </thead>
                <tbody class="main-table__body">
                    <template v-if="isLoading" >
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="5">
                                <div class="loader">
                                    <svg class="circular" viewBox="25 25 50 50">
                                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                                    </svg>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else-if="tableData">
                        <tr v-for="item in tableData" class="main-table__row-container">
                            <td class="main-table__row-item not-pointer-column">
                                {{ item.account_formatted }}
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                {{ item.account_name }}
                            </td>
                            <td class="main-table__row-item position-relative">
                                <multiselect
                                    @input="(value) => {updateBlocking(item.account_id, value, item.proxy_settings)}"
                                    :value="getMultiselectValues(item.proxy_settings)"
                                    :options="options"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    track-by="id"
                                    label="name"
                                    placeholder="Pick some"
                                />
                            </td>
                            <td v-if="ccb_feature" class="main-table__row-item not-pointer-column">
                                <toggle-button
                                    :value="false"
                                    :sync="true"
                                    :labels="false"
                                    :name="'status'"
                                    v-model="item.ccb_feature"
                                    @change="updateCCBFeature(item.account_id, item.ccb_feature)"
                                />
                            </td>
                            <td v-on:click.stop="thresholdRule(item.account_id)" class="main-table__row-item main-table__row-item_color_blue">
                                <div style="display: flex; justify-content: space-between; align-items: center;">
                                    <span>{{ item.threshold_clicks }} / {{ item.threshold_days }}</span>
                                    <span class="active-icon" style="margin-left: 5px;">
                                        <svg class="main-table__edit-icon" xml:space="preserve" style="enable-background:new 0 0 383.947 383.947;" viewBox="0 0 383.947 383.947" y="0px" x="0px" id="Capa_1" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" aria-label="My image"> <g xmlns="http://www.w3.org/2000/svg"><g><g><polygon points="0,303.947 0,383.947 80,383.947 316.053,147.893 236.053,67.893    "></polygon><path d="M377.707,56.053L327.893,6.24c-8.32-8.32-21.867-8.32-30.187,0l-39.04,39.04l80,80l39.04-39.04     C386.027,77.92,386.027,64.373,377.707,56.053z"></path></g></g></g></svg>
                                    </span>
                                </div>
                            </td>
                            <td class="main-table__row-item" style="color: #2280fe;" v-on:click="editUnblockIpAfter(item.account_id, item.unblock_after)">
                                <div style="display: flex; justify-content: space-between; align-items: center;">
                                    <span>{{ item.unblock_after == 1 ? item.unblock_after + " day" : item.unblock_after + " days" }}</span>
                                    <span class="active-icon" style="margin-left: 5px;">
                                        <svg class="main-table__edit-icon" xml:space="preserve" style="enable-background:new 0 0 383.947 383.947;" viewBox="0 0 383.947 383.947" y="0px" x="0px" id="Capa_1" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" aria-label="My image"> <g xmlns="http://www.w3.org/2000/svg"><g><g><polygon points="0,303.947 0,383.947 80,383.947 316.053,147.893 236.053,67.893    "></polygon><path d="M377.707,56.053L327.893,6.24c-8.32-8.32-21.867-8.32-30.187,0l-39.04,39.04l80,80l39.04-39.04     C386.027,77.92,386.027,64.373,377.707,56.053z"></path></g></g></g></svg>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="5">Not found</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <modal :height="'auto'" :width="'400px'" name="at-least-3-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Invalid action
                </div>
                <div class="body">
                    At least 3 types of proxy are required.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('at-least-3-modal')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'600px'" name="proxy-blocking-help-modal">
            <div class="informative-modal flex flex-col">
                <div class="header" style="padding-bottom: 32px;">
                    Proxy blocking
                </div>
                <div class="body">
                    <div class="proxy-tooltip">
                        <ul>
                            <li><b>VPN:</b> Anonymizing VPN services. These services offer users a publicly accessible VPN for the purpose of hiding their IP address.</li>
                            <li>&nbsp;</li>
                            <li><b>TOR:</b> Tor Exit Nodes. The Tor Project is an open network used by those who wish to maintain anonymity.</li>
                            <li>&nbsp;</li>
                            <li><b>HPD:</b> Hosting Provider and Data Center. Since hosting providers and data centers can serve to provide anonymity, the Anonymous IP database flags IP addresses associated with them.</li>
                            <li>&nbsp;</li>
                            <li><b>PUB:</b> Public Proxies. These are services that make connection requests on a user's behalf. Proxy server software can be configured by the administrator to listen to some specified port. These differ from VPNs in that the proxies usually have limited functions compare to VPNs.</li>
                            <li>&nbsp;</li>
                            <li><b>WEB:</b> Web Proxies. These are web services that make web requests on a user's behalf. These differ from VPNs or Public Proxies in that they are simple web-based proxies rather than operating at the IP address and other ports level.</li>
                        </ul>
                    </div>
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('proxy-blocking-help-modal')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'600px'" name="unblock-ip-help-modal">
            <div class="informative-modal flex flex-col">
                <div class="header" style="padding-bottom: 30px;">
                    Unblock IP after a period
                </div>
                <div class="body">
                    <div style="margin-bottom: 20px;">
                        By default, PPC Shield blocks the IP address for 30 days. If you wish, you may change this period to a number between 1 and 60.
                    </div>
                    <div style="margin-bottom: 20px;">
                        Using a value of 10, for example, the system will block the IP address from which the fraudulent click originated for 10 days.
                    </div>
                    <div style="margin-bottom: 20px;">
                        <div>
                            Note:
                        </div>
                        <ul style="list-style-type: disc; padding-left: 40px;">
                            <li>The update will affect already blocked IP addresses.</li>
                            <li>IP addresses may be released earlier if the number of blocked IP addresses per campaign exceeds 500.</li>
                        </ul>
                    </div>
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('unblock-ip-help-modal')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'400px'" name="threshold-rule-modal">
            <div class="informative-modal flex flex-col">
                <div class="header" style="padding-bottom: 30px;">
                    Threshold rule
                </div>
                <div class="body">
                    <div class="d-flex flex-row align-items-center">
                        <span style="white-space: nowrap; margin-right: 10px;">
                            Allow up to
                        </span>
                        <custom-input
                            name="allow_clicks"
                            type="text"
                            v-model="thresholdData.clicks"
                            :errors="thresholdData.errors"
                            :inputmask="['integer',{min:1, max:10}]"
                            hint="max 10"
                            style="margin-bottom: -22px;"
                        ></custom-input>
                        <span style="white-space: nowrap; margin: 0 10px;">
                            clicks within
                        </span>
                        <custom-input
                            name="allow_days"
                            type="text"
                            v-model="thresholdData.days"
                            :errors="thresholdData.errors"
                            :inputmask="['integer',{min:1, max:365}]"
                            hint="max 365"
                            style="margin-bottom: -22px;"
                        ></custom-input>
                        <span style="white-space: nowrap; margin-left: 10px;">
                            days
                        </span>
                    </div>
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn mr-2" @click="hideModal('threshold-rule-modal')">Cancel</button>
                    <button class="btn btn-primary" @click="updateThreshold()">Save</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'400px'" name="unblock-after-modal">
            <div class="informative-modal flex flex-col">
                <div class="header" style="padding-bottom: 30px;">
                    Unblock IP after a period
                </div>
                <div class="body">
                    <div style="margin-bottom: 20px;">
                        Enter a number between 1 and 60 to specify after how many days the IP address will be unblocked.
                    </div>
                    <div class="d-flex flex-row align-items-center">
                         <custom-input
                            name="unblock_after"
                            type="text"
                            style="margin-right: 20px; width: 50px!important;"
                            v-model="unblock_after.value"
                            :inputmask="['integer',{min:1, max:60}]"
                        ></custom-input>
                        <span>days</span>
                    </div>
                    <div class="main-form__label">
                        <span class="invalid-feedback"
                             v-if="unblock_after.errors && unblock_after.errors['unblock_after']"
                        >
                            <strong>{{unblock_after.errors['unblock_after'][0]}}</strong>
                        </span>
                    </div>

                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn mr-2" @click="hideModal('unblock-after-modal')">Cancel</button>
                    <button class="btn btn-primary" @click="onSaveUnblockAfter()">Save</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
   import ToggleButton from 'vue-js-toggle-button'
   import Multiselect from 'vue-multiselect'
   import {tableNumber, tableCurrency} from '../../helpers/graph-cards';

   Vue.use(ToggleButton);

   export default {
        name: 'blocked-ip',
        components: {
           Multiselect
        },
        props: ['ccb_feature'],
        data: function () {
            return {
                isLoading: false,
                tableData: null,
                value: [],
                options: [],
                thresholdData: {
                    account_id: 0,
                    clicks: 1,
                    days: 1,
                    errors: {}
                },
                filter: {
                    query: '',
                    sort: {
                        'column': '',
                        'sort': '',
                    }
                },
                show_tooltip: false,
                tableNumber: tableNumber,
                tableCurrency: tableCurrency,
                showAtLeast3: false,

                unblock_after: {
                    account_id: '',
                    value: 30,
                    errors: {},
                },
            }
        },
        mounted() {
            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            })
            this.getAccountData()
        },
        methods: {
            onSaveUnblockAfter(){
                if(!this.unblock_after.value || this.unblock_after.value < 1 || this.unblock_after.value > 60){
                    this.unblock_after.errors = {unblock_after: ['Error: the number should be between 1 and 60']};
                }
                else{
                    this.unblock_after.errors = {};

                    axios.post('settings/editUnblockAfter',
                        {
                            account_id: this.unblock_after.account_id,
                            days: this.unblock_after.value
                        })
                        .then((info) => {
                            if(info.data?.error){
                                this.unblock_after.errors = {unblock_after: [info.data?.error]};
                            }
                            else{
                                let account_settings = this.tableData.filter(x => x.account_id === this.unblock_after.account_id)[0];
                                account_settings.unblock_after = this.unblock_after.value;
                                this.hideModal('unblock-after-modal');
                            }
                        })
                        .catch(err => console.log('err', err));
                }
            },
            editUnblockIpAfter(account_id, unblock_days){
                this.unblock_after.account_id = account_id;
                this.unblock_after.value = unblock_days;
                this.unblock_after.errors = {};
                this.showModal('unblock-after-modal');
            },
            showModal(modal_name) {
                this.$modal.show(modal_name);
            },
            hideModal(modal_name) {
                this.$modal.hide(modal_name);
            },
            sortTable(event, column, type) {
                $(".sort-icon").removeClass("active-sort");
                let element = $(event.currentTarget);
                if(column === this.filter.sort.column) {
                    if(this.filter.sort.type === 'ASC') {
                        type = 'DESC';
                        $(element).find(".sort-icon-asc").addClass("active-sort");
                    }
                    else if(this.filter.sort.type === 'DESC') {
                        type = '';
                    }
                    else {
                        type = 'ASC';
                        $(element).find(".sort-icon-desc").addClass("active-sort");
                    }
                } else {
                    $(element).find(".sort-icon-desc").addClass("active-sort");
                }
                this.filter.sort.column = column;
                if(type === '') this.filter.sort.column = '';
                this.filter.sort.type = type;
                this.getAccountData();
            },
            getMultiselectValues(values) {
                return values.map(
                    i => {

                        return this.options.find(o => o.id === i);
                    }
                )
            },
            clearSearch() {
                this.filter.query = '';
                this.getAccountData();
            },
            getAccountData() {
                const last_search_value = this.filter.query;
                if(this.isLoading) return;
                this.isLoading = true;
                axios.get('settings/list',
                    {
                        params: {
                            query: this.filter.query,
                            column: this.filter.sort.column,
                            type: this.filter.sort.type,
                            timezone: new Date().getTimezoneOffset(),
                        }
                    })
                    .then(info => {
                        this.isLoading = false;
                        if(last_search_value === this.filter.query){
                            const {data: {items = [], types = []}} = info;
                            this.tableData = items;
                            this.options = types;
                        }
                        else{
                            this.getAccountData();
                        }
                    })
                    .catch(err => {
                        this.isLoading = false;
                        console.log('err', err);
                    });
            },
            updateBlocking(account_id, settings, old_setting) {
                if((!settings && old_setting) || (settings.length < 3 && settings.length < old_setting.length)){
                    this.showModal('at-least-3-modal');
                    return;
                }
                axios.post('settings/editProxyStatus',
                    {
                        account_id: account_id, settings: (settings ?? []).map(i => i.id)
                    })
                    .then(() => {
                        this.getAccountData()
                    })
                    .catch(err => console.log('err', err));
            },
            thresholdRule(account_id) {
                let result = this.tableData.filter(x => x.account_id === account_id);
                this.thresholdData.account_id = result[0].account_id;
                this.thresholdData.clicks = result[0].threshold_clicks ?? 3;
                this.thresholdData.days = result[0].threshold_days ?? 30;
                this.showModal('threshold-rule-modal');
            },
            updateThreshold() {
                axios.post('settings/editThresholdStatus',
                    {
                        account_id: this.thresholdData.account_id,
                        clicks: this.thresholdData.clicks,
                        days: this.thresholdData.days
                    })
                    .then(() => {
                        let account_settings = this.tableData.filter(x => x.account_id === this.thresholdData.account_id)[0];
                        account_settings.threshold_clicks = this.thresholdData.clicks;
                        account_settings.threshold_days = this.thresholdData.days;
                        this.hideModal('threshold-rule-modal');
                    })
                    .catch(err => console.log('err', err));
            },
            updateCCBFeature(account_id, ccb_feature) {
                axios.post('settings/editCCBStatus',
                    {
                        account_id: account_id,
                        ccb_feature: ccb_feature
                    })
                    .then(() => {

                    })
                    .catch(err => console.log('err', err));
            },
        }
    }
</script>
